import { render, staticRenderFns } from "./Display.vue?vue&type=template&id=4ec7ffc3&scoped=true&"
import script from "./Display.vue?vue&type=script&lang=js&"
export * from "./Display.vue?vue&type=script&lang=js&"
import style0 from "./Display.vue?vue&type=style&index=0&id=4ec7ffc3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec7ffc3",
  null
  
)

export default component.exports